import React, { useState } from 'react';
import { Typography, Breadcrumb, Card, Form, Input, Switch, Button, Space, Collapse, message } from 'antd';

const { Title, Paragraph } = Typography;
const { Panel } = Collapse;

const OtherPlatforms = () => {
  const [saving, setSaving] = useState(false);
  const [form] = Form.useForm();

  const onSubmit = async () => {
    try {
      // Basic validation could be extended per platform
      setSaving(true);
      // PUT /api/client/integrations/other
      await new Promise(r => setTimeout(r, 350));
      message.success('Other platform settings saved');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <Breadcrumb items={[{ title: 'Client' }, { title: 'Integrations' }, { title: 'Other Platforms' }]} />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 12, marginBottom: 16 }}>
        <Title level={3} style={{ margin: 0 }}>Other Ad Platforms</Title>
        <Space><Button type="primary" onClick={onSubmit} loading={saving}>Save</Button></Space>
      </div>
      <Card>
        <Paragraph type="secondary">Connect additional ad platforms and webhooks.</Paragraph>
        <Form layout="vertical" form={form}>
          <Collapse>
            <Panel header="TikTok Ads" key="tiktok">
              <Form.Item label="App ID" name="tiktokAppId"><Input placeholder="TikTok App ID" /></Form.Item>
              <Form.Item label="App Secret" name="tiktokSecret"><Input.Password placeholder="TikTok App Secret" /></Form.Item>
              <Form.Item label="Enabled" name="tiktokEnabled" valuePropName="checked"><Switch /></Form.Item>
            </Panel>
            <Panel header="LinkedIn Ads" key="linkedin">
              <Form.Item label="Client ID" name="linkedinClientId"><Input placeholder="LinkedIn Client ID" /></Form.Item>
              <Form.Item label="Client Secret" name="linkedinClientSecret"><Input.Password placeholder="LinkedIn Client Secret" /></Form.Item>
              <Form.Item label="Enabled" name="linkedinEnabled" valuePropName="checked"><Switch /></Form.Item>
            </Panel>
            <Panel header="Webhooks" key="webhooks">
              <Form.Item label="Webhook URL" name="webhookUrl"><Input placeholder="https://example.com/webhook" /></Form.Item>
              <Form.Item label="Secret" name="webhookSecret"><Input.Password placeholder="Signing secret" /></Form.Item>
              <Form.Item label="Enabled" name="webhookEnabled" valuePropName="checked"><Switch /></Form.Item>
            </Panel>
          </Collapse>
        </Form>
      </Card>
    </div>
  );
};

export default OtherPlatforms;
